import { useEffect } from "react";
import { X } from "lucide-react";
import SurveiPublik from "@/pages/SurveiPublik";

// Pratinjau formulir peserta dari draf (editor butir): komponen publik yg SAMA (pendahuluan berangka draf, bagian, bilah
// kemajuan) dalam mode pratinjau -- tidak memanggil API & tidak bisa mengirim. Lapisan layar penuh di atas menu admin.
export default function SurveiPratinjauFormulir({ butir, onTutup }) {
    useEffect(() => {
        const esc = (e) => { if (e.key === "Escape") onTutup(); };
        window.addEventListener("keydown", esc);
        return () => window.removeEventListener("keydown", esc);
    }, [onTutup]);
    return (
        <div role="dialog" aria-modal="true" aria-label="Pratinjau formulir survei" data-testid="survei-pratinjau-formulir"
             className="fixed inset-0 z-50 overflow-y-auto bg-background">
            <button type="button" onClick={onTutup} data-testid="survei-pratinjau-tutup"
                    className="fixed left-3 top-3 z-[60] flex items-center gap-1 rounded-lg border border-border bg-card px-3 py-2 text-sm font-semibold shadow">
                <X className="h-4 w-4" aria-hidden="true" /> Tutup pratinjau
            </button>
            <SurveiPublik pratinjau={butir} />
        </div>
    );
}
